import gql from 'graphql-tag'

const saveCostoMensile = gql`
  mutation saveCostoMensile($costoMensile: SaveCostoMensile!) {
    saveCostoMensile(costoMensile: $costoMensile) {
      tipoCampagnaId
      costo
    }
  }
`

export default saveCostoMensile


// WEBPACK FOOTER //
// ./src/graphql/mutations/saveCostoMensile.js